module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.9b6d74a.woff";